import styled from 'styled-components'

export const TextAreaStyle = styled.div<{ widthDiv: string; isValidate: boolean }>`
  box-sizing: border-box;
  width: ${({ widthDiv }) => widthDiv};
  display: flex;
  flex-direction: column;
  margin-top: 5px;

  label {
    color: ${({ theme }) =>
      ({ isValidate }) => {
        if (isValidate) {
          return theme.colors.primary
        } else {
          return theme.colors.error
        }
      }};
    font-size: ${({ theme }) => theme.fonts.size.normal};
    font-weight: ${({ theme }) => theme.fonts.weight.normal};
    margin-bottom: 5px;
  }

  textarea {
    width: 100%;
    height: 200px;
    box-sizing: border-box;
    padding: 10px;
    outline: none;
    resize: none;
    border-radius: ${({ theme }) => theme.borderRadius.small};
    border: ${({ theme }) => theme.border};
    border-color: ${({ theme }) =>
      ({ isValidate }) => {
        if (isValidate) {
          return theme.colors.border
        } else {
          return theme.colors.error
        }
      }};
    font-family: 'Ubuntu', sans-serif;
    font-size: ${({ theme }) => theme.fonts.size.normal};
    font-weight: ${({ theme }) => theme.fonts.weight.thin};
    &::placeholder {
      color: ${({ theme }) =>
        ({ isValidate }) => {
          if (isValidate) {
            return theme.colors.border
          } else {
            return theme.colors.error
          }
        }};
    }
    scrollbar-color: ${({ theme }) => theme.colors.primary} ${({ theme }) => theme.colors.border};
    scrollbar-width: thin;
    &::-webkit-scrollbar {
      width: 10px;
      background-color: ${({ theme }) => theme.colors.border};
      border-radius: 0 5px 5px 0;
    }
    &::-webkit-scrollbar-thumb {
      width: 5px;
      background-color: ${({ theme }) => theme.colors.primary};
      border-radius: 0 5px 5px 0;
      cursor: pointer;
    }
  }

  @media screen and (max-width: 720px) {
    label {
      font-size: ${({ theme }) => theme.fonts.size.small};
      margin-bottom: 3px;
    }
    textarea {
      height: 100px;
      padding: 7px;
      font-size: ${({ theme }) => theme.fonts.size.small};
    }
  }

  @media screen and (max-width: 480px) {
    width: 100%;
    label {
      font-size: ${({ theme }) => theme.fonts.size.superSmall};
      margin-bottom: 1.5px;
    }
    textarea {
      font-size: ${({ theme }) => theme.fonts.size.superSmall};
    }
  }
`
